import request from '@/utils/request'

// 查询支行分页
export function pageBranch(query) {
  return request({
    url: '/shop/branch/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}
